import React from "react";
import PdfViewer from "../../PdfViewer";

const BajaColaboradorProcedimiento = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/baja-colaborador-proceso.pdf`;
  /*const pdfUrl = "/pdf/baja-colaborador-proceso.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Solicitud de Baja de Colaborador</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default BajaColaboradorProcedimiento;
